import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import { PrivacyPolicy, Terms } from "@/pages/LegalPage";
import CookiePolicy from "@/pages/CookiePolicy";
import ThankYou from "@/pages/ThankYou";

const LangLayout = () => <Layout />;

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/ar" replace />} />

          <Route path="/ar" element={<LangLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="terms-conditions" element={<Terms />} />
          </Route>

          <Route path="/en" element={<LangLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="terms-conditions" element={<Terms />} />
          </Route>

          <Route path="/thank_you" element={<Layout />}>
            <Route index element={<ThankYou />} />
          </Route>

          <Route path="*" element={<Navigate to="/ar" replace />} />
        </Routes>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
